function Spacer({data}) {
	return (<div style={{height:data.size}}></div>);
};
export default Spacer;
